import { useEffect } from 'react';

// Prevents native gesture events (pinch-to-zoom, etc) on touch devices.
export function useGestureOverride() {
    useEffect(() => {
        const preventDefault = (e: Event) => e.preventDefault();

        document.addEventListener('gesturestart', preventDefault);
        document.addEventListener('gesturechange', preventDefault);
        document.addEventListener('gestureend', preventDefault);

        return () => {
            document.removeEventListener('gesturestart', preventDefault);
            document.removeEventListener('gesturechange', preventDefault);
            document.removeEventListener('gestureend', preventDefault);
        };
    }, []);
}
